<script>
export default {
    emits: ['register', 'login', 'skip'],
    props: {
        message: {
            type: String,
            default: '',
        },
        isBusy: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            mode: 'register',
            register: {
                name: '',
                email: '',
                password: '',
            },
            login: {
                login: '',
                password: '',
            },
        }
    },
    methods: {
        submitRegister() {
            this.$emit('register', { ...this.register });
        },
        submitLogin() {
            this.$emit('login', { ...this.login });
        },
        setMode(mode) {
            this.mode = mode;
        },
    },
}
</script>
<template>
    <div class="aktion-quiz-auth">
        <div class="aktion-quiz-auth__panel">
            <p class="aktion-quiz-auth__message" v-if="message">{{ message }}</p>

            <div class="aktion-quiz-auth__tabs">
                <button type="button" class="aktion-quiz-auth__tab" :class="{ 'is-active': mode === 'register' }" @click="setMode('register')">Create Account</button>
                <button type="button" class="aktion-quiz-auth__tab" :class="{ 'is-active': mode === 'login' }" @click="setMode('login')">Log In</button>
            </div>

            <p class="aktion-quiz-auth__error" v-if="errorMessage">{{ errorMessage }}</p>

            <form class="aktion-quiz-auth__form" v-if="mode === 'register'" @submit.prevent="submitRegister">
                <input class="aktion-quiz-auth__input" type="text" placeholder="Display Name (optional)" v-model="register.name">
                <input class="aktion-quiz-auth__input" type="email" placeholder="Email Address" v-model="register.email" required>
                <input class="aktion-quiz-auth__input" type="password" placeholder="Password (min 8 characters)" v-model="register.password" required>
                <button class="aktion-quiz-auth__submit" type="submit" :disabled="isBusy">
                    {{ isBusy ? 'Please wait…' : 'Save My Score' }}
                </button>
            </form>

            <form class="aktion-quiz-auth__form" v-else @submit.prevent="submitLogin">
                <input class="aktion-quiz-auth__input" type="text" placeholder="Email or Username" v-model="login.login" required>
                <input class="aktion-quiz-auth__input" type="password" placeholder="Password" v-model="login.password" required>
                <button class="aktion-quiz-auth__submit" type="submit" :disabled="isBusy">
                    {{ isBusy ? 'Please wait…' : 'Log In & Save Score' }}
                </button>
            </form>

            <button type="button" class="aktion-quiz-auth__skip" @click="$emit('skip')" :disabled="isBusy">
                No thanks, just show my results
            </button>
        </div>
    </div>
</template>
